import React from "react";
import { useBreakpoints } from "../../../hooks";
import HorizontalNavigation from "./horizontal/HorizontalNavigation";
import { MobileNavigation } from "./mobile";
import { ActivePathContextProvider } from "./shared/ActivePathContext";
import { VerticalNavigation } from "./vertical";
const Navigation = ({ config, customLinkComponent, children, vertical = false }) => {
    // hooks
    const { isMobile } = useBreakpoints();
    // constants
    const props = { config, customLinkComponent };
    // render
    if (isMobile) {
        return React.createElement(MobileNavigation, { ...props });
    }
    if (vertical) {
        return (React.createElement(ActivePathContextProvider, { navLinks: config.navigationLinks },
            React.createElement(VerticalNavigation, { ...props }, children)));
    }
    return (React.createElement(ActivePathContextProvider, { navLinks: config.navigationLinks },
        React.createElement(HorizontalNavigation, { ...props })));
};
export default Navigation;
//# sourceMappingURL=Navigation.js.map